import { saveAssessmentDraft, getAssessmentDraft, deleteAssessmentDraft } from '@/api/selfassessment'

export default {
  data() {
    return {
      draftReady: false,
      draftDirty: false,
      draftSaving: false,
      draftSavedAt: null,
      draftTimer: null
    }
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        if (!this.draftReady || this.showResult) return
        this.draftDirty = true
        this.scheduleDraftSave()
      }
    },
    companyType() {
      if (!this.draftReady || this.showResult) return
      this.draftDirty = true
      this.scheduleDraftSave()
    }
  },
  beforeDestroy() {
    if (this.draftTimer) clearTimeout(this.draftTimer)
  },
  methods: {
    draftDomain() { return this.$options.assessmentDraftDomain },
    scheduleDraftSave() {
      if (this.draftTimer) clearTimeout(this.draftTimer)
      this.draftTimer = setTimeout(() => this.saveCurrentDraft(false), 1500)
    },
    compactDraftAnswers() {
      const result = {}
      Object.keys(this.formData || {}).forEach(id => {
        const values = this.formData[id] || {}
        const filled = {}
        Object.keys(values).forEach(key => {
          const value = values[key]
          if (value !== '' && value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0)) filled[key] = value
        })
        if (Object.keys(filled).length > 0) result[id] = filled
      })
      return result
    },
    async saveCurrentDraft(manual) {
      if (!this.draftReady || this.showResult || this.draftSaving) return
      if (this.draftTimer) { clearTimeout(this.draftTimer); this.draftTimer = null }
      const answers = this.compactDraftAnswers()
      if (!manual && Object.keys(answers).length === 0) return
      this.draftSaving = true
      try {
        const draft = await saveAssessmentDraft(this.draftDomain(), answers, this.companyType || null)
        this.draftSavedAt = draft && draft.savedAt ? draft.savedAt : new Date().toISOString()
        this.draftDirty = false
        if (manual) this.$message.success('草稿已暂存')
      } catch (error) {
        if (manual) this.$message.error('草稿暂存失败，请稍后重试')
      } finally {
        this.draftSaving = false
        if (this.draftDirty) this.scheduleDraftSave()
      }
    },
    async initializeAssessmentDraft(latestResult) {
      this.evaluationResult = latestResult || null
      let draft = null
      try { draft = await getAssessmentDraft(this.draftDomain()) } catch (error) { /* 无草稿或未登录 */ }
      if (draft && draft.answers && Object.keys(draft.answers).length > 0) {
        if (draft.companyType && Object.prototype.hasOwnProperty.call(this, 'companyType')) this.companyType = draft.companyType
        this.restoreDraftAnswers(draft.answers)
        this.draftSavedAt = draft.savedAt || null
        this.isEditing = Boolean(latestResult && latestResult.assessmentId)
        this.showResult = false
      } else if (latestResult && latestResult.assessmentId) {
        this.showResult = true
      }
      this.$nextTick(() => { this.draftReady = true; this.draftDirty = false })
    },
    restoreDraftAnswers(answers) {
      Object.keys(answers || {}).forEach(id => {
        const target = this.formData[id]
        if (!target) return
        Object.keys(answers[id] || {}).forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(target, key)) return
          const value = answers[id][key]
          this.$set(target, key, value)
          if (Array.isArray(value) && this.checkboxPrevious) this.$set(this.checkboxPrevious, `${id}:${key}`, value.slice())
        })
      })
      if (typeof this.syncLinkedCalculatedFields === 'function') this.syncLinkedCalculatedFields()
    },
    async clearCurrentDraft() {
      if (this.draftTimer) { clearTimeout(this.draftTimer); this.draftTimer = null }
      try { await deleteAssessmentDraft(this.draftDomain()) } catch (error) { /* 不影响正式提交 */ }
      this.draftSavedAt = null
      this.draftDirty = false
    },
    draftStatusText() {
      if (this.draftSaving) return '正在自动保存…'
      if (this.draftDirty) return '有尚未保存的修改'
      if (!this.draftSavedAt) return '填写内容将在停止操作后自动暂存'
      const date = new Date(this.draftSavedAt)
      if (Number.isNaN(date.getTime())) return '草稿已保存'
      return `草稿已保存 ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    }
  }
}
